import type { ApplicationVerifier } from 'firebase/auth';
import type { ConfirmationResult } from '@/core/services';
import { firebaseAuthService } from '@/core/services';

export class ReenviarCodigoUseCase {
  async execute(phoneNumber: string, appVerifier: ApplicationVerifier): Promise<ConfirmationResult> {
    return firebaseAuthService.resendVerificationCodeToPhone(phoneNumber, appVerifier);
  }
}
